import { useContext } from 'react';
import { CurrentCandidateContext } from 'providers/CurrentCandidateProvider';

const useCurrentCandidate = () => useContext(CurrentCandidateContext);
export default useCurrentCandidate;
